import { ReactElement } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    FormDataConsumer,
    FormDataConsumerRenderParams,
    SelectArrayInput,
    useCreateSuggestionContext
} from 'react-admin';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
} from '@mui/material';
import { NokEmailTemplateCodeEditor } from "../code-editor/NokEmailTemplateCodeEditor";
import { JSX, useState } from "react";
import { useASettingByCode } from "../global-hooks/default-system-hooks";
import { DefaultDepartmentTags } from "../../types/types";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";
import { NokEmailTemplateTargetInputs } from "./components/Noks/NokEmailTemplateTargetInputs";

type SelectOptions = { id: string; name: string };

const CreateTag: (props: {
    choices: SelectOptions[]
}) => JSX.Element = (props: {
    choices: SelectOptions[]
}): JSX.Element => {
    const { onCancel, onCreate } = useCreateSuggestionContext();
    const [value, setValue] = useState('');

    const handleSubmit = event => {
        event.preventDefault();
        const newOption = { id: value, name: value };
        props?.choices.push(newOption);
        setValue('');
        onCreate(newOption);
    };
    return (
        <Dialog open onClose={onCancel}>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <TextField
                        label="Role name"
                        value={value}
                        onChange={event => setValue(event.target.value)}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit">Save</Button>
                    <Button onClick={onCancel}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}


export const NokEmailTemplateEdit: () => JSX.Element = (): JSX.Element => {
    const { loadingSetting, settingValue, loadSettingValue, error } = useASettingByCode("default_department_tags");

    const types: { id: string, name: string }[] = [
        { id: 'email_wrapper', name: 'Email Wrapper' },
        { id: 'ms_email_body', name: 'Mystery Shopper Message Body' },
        { id: 'ms_form_message', name: 'Mystery Shopper Form Message' },
        { id: 'cs_email_body', name: 'Compliance Sniffer Message Body' },
        { id: 'cs_form_message', name: 'Compliance Sniffer Form Message' },
    ];

    let tagValues: SelectOptions[] = [];
    if (settingValue) {
        let tags: { key: string, value: string }[] = JSON.parse(settingValue) ?? [];
        for (let i: number = 0; i < tags.length; i++) {
            let tag: DefaultDepartmentTags = tags[i];
            tagValues.push({
                id: tag.key,
                name: tag.value
            });
        }
    }

    return (
        <Edit redirect={ false }>
            <SimpleForm  >
                <TextInput source="name" validate={[required()]} />
                <SelectInput source="type" choices={ types } validate={ [required()] } />
                <NokEmailTemplateTargetInputs />
                <TextInput source="subject" validate={[required()]} />
                { (loadingSetting) &&
                    <Box sx={ { width: '100%', height: '40px' } }>
                        <span>{ "Loading..." }</span>
                    </Box>
                }
                { (!loadingSetting) &&
                    <SelectArrayInput source="tags"
                                      choices={ tagValues }
                                      onCreate={ (): { id: string, name: string } => {
                                          let newChoice: string = prompt("Enter a new tag");
                                          newChoice = newChoice.replaceAll(' ', '_').toLowerCase();
                                          const newChoiceOption = {
                                              id: newChoice,
                                              name: newChoice,
                                          };
                                          tagValues.push(newChoiceOption);
                                          return newChoiceOption;
                                      } }

                    />
                }
                <FormDataConsumer<{ type: string }>>
                    {({
                          formData,
                          scopedFormData,
                          ...rest
                      }: FormDataConsumerRenderParams<{ type: string }>): ReactElement => {
                        if (formData?.type.toLowerCase().includes('form')) {
                            return (
                                <TextInput source="html" validate={[required()]} multiline rows={ 15 } />
                            );
                        }
                        return (
                            <NokEmailTemplateCodeEditor  />
                        );
                    } }
                </FormDataConsumer>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
